// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-29T23:17:37.413Z
// Property: Dakota Ridge (ID: 5693657831178240)
// Collections: 23 amenities, 6 floorplans (live), 9 photos, 12 POIs, 5 reviews, 4 virtual tours, 5 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "5693657831178240",
  "property_external_id": "889464",
  "property_zillow_url": "https://www.zillow.com/apartments/williston-nd/dakota-ridge/64yRGM/",
  "property_apartments_url": "https://www.apartments.com/dakota-ridge-williston-nd/l93p3nf/",
  "property_google_business_url": "https://www.google.com/maps/place/Dakota+Ridge/data=!4m2!3m1!1s0x0:0x4b62114e29eb6619?sa=X&ved=2ahUKEwiNieSbp7iSAxWmppUCHb1SHosQ_BJ6BAgYEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "47606919339",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "dakota-ridge",
  "property_name": "Dakota Ridge",
  "property_website_url": "https://www.dakotaridgeapartmenthomes.com",
  "property_domain": "https://www.dakotaridgeapartmenthomes.com",
  "property_address": "5963 US-85",
  "property_full_address": "5963 US-85, Williston, ND 58801",
  "property_address_1": "5963 US-85",
  "property_address_2": null,
  "property_address_city": "Williston",
  "property_address_state": "ND",
  "property_address_zip_full": null,
  "property_address_zip": "58801",
  "property_address_country": "US",
  "property_address_county": "Williams County",
  "property_neighborhood_address": "North Dakota Area",
  "property_address_latitude": "48.27871234421049",
  "property_address_longitude": "-103.6272915875334",
  "property_email": "dakotaridge@weidner.com",
  "property_phone": "(701) 204-0014",
  "property_call_tracking_phone": "701-204-0014",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Modern comfort with wide-open Williston convenience.</strong> Explore spacious two- and three-bedroom <a href=\"/floor-plans\">floor plans</a> with full-size washers and dryers, private balconies, and select oversized two-car garages—then <a href=\"/schedule-a-tour\">schedule a tour</a> to see Dakota Ridge for yourself.</p>",
  "property_long_description": "<p><strong>Modern comfort with wide-open Williston convenience.</strong> At Dakota Ridge, you can settle into a relaxed north Williston setting with the finishes, space, and everyday ease that make home feel effortless. Choose from spacious two- and three-bedroom <a href=\"/floor-plans\">floor plans</a> with full-size washers and dryers, wood-style flooring, black appliances, double vanities, private balconies, and built-in desks, with select homes offering granite countertops, vaulted ceilings, and oversized two-car garages.</p><p>Beyond your front door, <a href=\"/amenities\">community amenities</a> add room to recharge, focus, and connect: a fitness center, business center, resident lounge with entertainment kitchen, game room, BBQ grills, walking paths, on-site maintenance, online payments, and electrical outlets in parking for block heaters. The pet-friendly setting includes a large dog park, while the US-85 location keeps you close to Missouri Ridge Commercial Park, Eagle Ridge Golf Course, Spring Lake Park, Williston Basin International Airport, downtown dining, local shopping, and the prairie landscapes of western North Dakota.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5693657831178240/019d019f-f9c4-714d-9404-f5f8cb6911fc.webp",
  "property_featured_image_media": {
    "alt_text": "Living room with a light gray sofa, coffee table, and TV.",
    "public_id": "019d019f-f9c4-714d-9404-f5f8cb6911fc",
    "storage_key": "property/5693657831178240/019d019f-f9c4-714d-9404-f5f8cb6911fc.webp",
    "width": 1536,
    "height": 1024
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "180",
  "property_year_built": "2014",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "95.55555555555556",
  "property_admin_fee": null,
  "property_application_fee": "50",
  "property_fees_deposit_info": "Security Deposit: $750",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "250",
  "property_pet_deposit": "250",
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "50",
  "property_pet_restrictions": "Breed restrictions apply",
  "property_pet_policy_description": "Up to 2 pets per home are welcome.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://dakotaridgeapartmenthomes.securecafe.com/onlineleasing/dakota-ridge-4/floorplans.aspx",
  "property_resident_portal_url": "https://dakotaridgeapartmenthomes.securecafenet.com/residentservices/dakota-ridge-4/userlogin",
  "property_apply_now_url": "https://dakotaridgeapartmenthomes.securecafe.com/onlineleasing/dakota-ridge-4/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5693657831178240/019d01a0-93a0-76cf-9d66-1c3154084e45.webp",
  "property_primary_logo_media": {
    "alt_text": "Dakota Ridge Apartment Homes logo with circular emblem",
    "public_id": "019d01a0-93a0-76cf-9d66-1c3154084e45",
    "storage_key": "property/5693657831178240/019d01a0-93a0-76cf-9d66-1c3154084e45.webp",
    "width": 3072,
    "height": 942
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5693657831178240/019d01a1-8abb-73e6-aadf-15a887a68531.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Dakota Ridge Apartment Homes logo",
    "public_id": "019d01a1-8abb-73e6-aadf-15a887a68531",
    "storage_key": "property/5693657831178240/019d01a1-8abb-73e6-aadf-15a887a68531.webp",
    "width": 640,
    "height": 196
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5693657831178240/019d01a1-962a-76fd-a311-4c30ecd6f399.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Dakota Ridge Apartment Homes logo",
    "public_id": "019d01a1-962a-76fd-a311-4c30ecd6f399",
    "storage_key": "property/5693657831178240/019d01a1-962a-76fd-a311-4c30ecd6f399.webp",
    "width": 640,
    "height": 196
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#6b1f1f",
  "property_secondary_color": "#98533e",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#d4beaf",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "2 - 3",
  "property_bedrooms_min": "2",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "2 - 2",
  "property_bathrooms_min": "2",
  "property_bathrooms_max": "2",
  "property_sqft_range": " - 1202",
  "property_sqft_min": "931",
  "property_sqft_max": "1202",
  "property_price_range": "1103.15 - 1529.15",
  "property_price_min": "1103.15",
  "property_price_max": "1529.15",
  "property_available_units": 16,
  "property_facebook_url": "https://www.facebook.com/DakotaRidgeApartmentHomes/",
  "property_instagram_url": "https://www.instagram.com/dakotaridgeapthomes/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJyU4mnjFdIVMRGWbrKU4RYks",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Dakota Ridge",
  "property_home_romance_title": "Discover Comfort and Community Living",
  "property_home_amenities_blurb": "<p><strong>Everyday ease, Dakota Ridge style.</strong> Enjoy apartment features that pull their weight, from full-size washers and dryers to built-in desks, double vanities, wood-style flooring, and private balconies. Beyond your door, recharge or get things done with a fitness center, business center, resident lounge, game room, BBQ grills, walking paths, and a large dog park—all with practical perks like on-site maintenance, online payments, smoke-free surroundings, and block-heater outlets in parking.</p>",
  "property_home_floorplans_blurb": "<p><strong>Space that works harder.</strong> Explore two- and three-bedroom, two-bath floor plans at Dakota Ridge with open layouts, full-size washers and dryers, wood-style flooring, black appliances, double vanities, private balconies, and built-in desks. Select homes add granite countertops, vaulted ceilings, or oversized two-car garages—giving you more room to match your day.</p>",
  "property_home_gallery_blurb": "<p><strong>Get a closer look at Dakota Ridge.</strong> Preview bright interiors with wood-style flooring, sleek kitchens with dark appliances, built-in desks, in-home laundry, and balconies in select layouts. Then browse community spaces made for downtime, from a lounge with an entertainment kitchen to a game room, fitness center, BBQ areas, walking paths, and pet-friendly green space.</p>",
  "property_home_neighborhood_blurb": "<p>Embrace a lifestyle close to top Williston destinations, including Eagle Ridge Golf Course, parks, shopping, and restaurants. Dakota Ridge offers access to Highway 2, a short drive to Williston Basin International Airport, and just under 15 minutes from downtown. Whether you want an easy commute or places for fun on the weekends, Dakota Ridge puts you near it all.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents have plenty to say about Dakota Ridge.</strong> Reviews praise the friendly, communicative team, smooth move-in support, beautiful apartment finishes, pet-friendly touches, a favorite fitness space, and maintenance known for fast responses. Set a few miles outside town with open surroundings, Dakota Ridge earns standout feedback—including “Best apartments in Williston!”</p>",
  "property_neighborhood_blurb": "<p>Dakota Ridge places you close to everything that makes Williston special. Step outside for afternoons at nearby parks or golf at Eagle Ridge. Quick highway access gets you to downtown or Williston Basin International Airport in under 15 minutes. From grocery stores to nightlife, the city's best dining, shopping, and recreation are all within reach, so you can spend more time enjoying the community's vibe and less time getting there.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>Enjoy everyday perks with Dakota Ridge's full list of comforts. Every apartment includes double vanities, full-size washers and dryers, and stylish wood-style flooring. The community adds more to your day with useful amenities, like a fitness center, resident lounge, large dog park, and rentable oversized garages. Everyday tasks are easier, and downtime is more enjoyable in a community designed for comfort.</p>",
  "property_applynow_blurb": "<p><strong>Ready to make Dakota Ridge home?</strong> Start your online application for a spacious two- or three-bedroom apartment with everyday comforts like full-size washers and dryers, wood-style flooring, private balconies, and pet-friendly convenience. Explore available <a href=\"/floor-plans\">floor plans</a>, then apply with confidence.</p>",
  "property_contactus_blurb": "<p>Let's connect about your next home. Contact our dedicated leasing team at Dakota Ridge in Williston, ND, to learn more, ask questions, or schedule a tour. We're here to help guide you to your perfect apartment.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Dakota Ridge?</strong> Start here for quick answers about the community, leasing, everyday living, and the features that make home feel effortless. If you don’t see what you need, the leasing team is happy to help with details or next steps.</p>",
  "property_floorplans_blurb": "<p>At Dakota Ridge, our roomy two- and three-bedroom apartments are made for the way you live. Enjoy space for every need, with layouts that easily fit your furniture, a built-in desk for working from home, and plenty of storage. Each apartment includes wood-style flooring, an in-unit washer and dryer, and a private balcony, making sure you feel right at home. Each layout offers the right mix of privacy and shared living space for any routine.</p>",
  "property_gallery_blurb": "<p>See what life feels like at Dakota Ridge. Imagine relaxing in your living room with wood-style floors, checking out high-end kitchens, taking in community spaces, and exploring roomy bedrooms. From inviting lounges to vibrant outdoor areas, picture stepping into a community that feels as comfortable as home.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Dakota Ridge on the map.</strong> See available apartments in north Williston, then zoom out to discover the everyday convenience surrounding this US-85 location—from downtown dining and local shopping to parks, golf, the airport, and open western North Dakota landscapes.</p>",
  "property_pets_blurb": "<p><strong>Room to roam, rinse, and relax.</strong> At Dakota Ridge, pet-friendly living fits naturally into your day, from quick fresh-air breaks to longer strolls along the community walking paths. The large dog park gives your pup a dedicated place to burn off energy, while spacious layouts, wood-style flooring, and in-home laundry help keep life with paws a little easier.</p><p>Settle into a home in Williston where your pet’s routine has space outside your door and comfort waiting inside. Review the policy details below, explore more <a href=\"/amenities\">pet-friendly amenities</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see the dog park and community spaces in person.</p>",
  "property_referafriend_blurb": "<p><strong>Share Dakota Ridge with a friend.</strong><br>Love the spacious two- and three-bedroom homes, full-size washers and dryers, private balconies, and relaxed north Williston setting? Invite a friend to discover the modern comfort and everyday ease you enjoy here.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access made easy.</strong> Pay rent online, submit maintenance requests, and manage your Dakota Ridge account from one convenient place—so everyday home details stay as effortless as the modern comfort around you.</p>",
  "property_reviews_blurb": "<p><strong>Hear what residents are saying about Dakota Ridge.</strong> Reviews highlight a team that is friendly, clear, and willing to go “above and beyond,” from application help to smooth move-in support.</p><p>Residents also call out beautiful apartment finishes, helpful pet accommodations, a well-liked fitness space, and maintenance that delivers a “fast response” when something needs attention. Add in a setting a few miles outside town with open surroundings, and it’s easy to see why one reviewer called Dakota Ridge the “Best apartments in Williston!”</p>",
  "property_created_at": "1752256529975",
  "property_scheduletour_blurb": "<p>Ready to picture yourself at Dakota Ridge? Schedule a tour and discover two- and three-bedroom apartments with built-in desks and wood-style floors. Take a guided in-person or live virtual tour, and our leasing team will help you explore every corner. Touring restrictions may apply - we're here to make your next steps as easy as possible.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you — your inquiry has been received.</strong><br>Our leasing team will be in touch soon. In the meantime, picture the ease of Dakota Ridge: spacious two- and three-bedroom homes, modern finishes, everyday conveniences, and a relaxed north Williston setting with room to recharge and feel at home.</p>",
  "property_virtualtours_blurb": "<p>Get an inside look at Dakota Ridge with our virtual tour gallery. Stroll through bright living rooms, view sample floor plans, and get a sense of the community's welcoming feel - all from your phone or laptop. Whether moving from out of state or fitting a tour into your busy day, take in the flow of our spaces and imagine where you'll make your next home. For a closer look, reach out for a personal in-person or live virtual tour.</p>",
  "property_copyright": "2026 All Rights Reserved. Dakota Ridge",
  "property_seo_title_home": "Relaxed Apartment Living | Dakota Ridge | Williston, ND",
  "property_seo_description_home": "Pet-friendly apartments at Dakota Ridge in Williston, ND, close to parks and Missouri Ridge Commercial Park. Flexible leases are available.",
  "property_seo_title_floorplans": "Spacious Floor Plans | Dakota Ridge | Williston, ND",
  "property_seo_description_floorplans": "Explore two- and three-bedroom apartment floor plans at Dakota Ridge in Williston, ND - designed for comfort, style, and flexibility.",
  "property_seo_title_amenities": "Modern Amenities | Dakota Ridge | Williston, ND",
  "property_seo_description_amenities": "Live with comfort and convenience at Dakota Ridge in Williston, ND - enjoy in-home laundry, pet-friendly spaces, and more.",
  "property_seo_title_gallery": "Photo Gallery | Dakota Ridge | Williston, ND",
  "property_seo_description_gallery": "Picture yourself at Dakota Ridge in Williston, ND - browse photos of floor plans, inviting social spaces, and everyday comforts.",
  "property_seo_title_virtualtours": "Virtual Tour | Dakota Ridge | Williston, ND",
  "property_seo_description_virtualtours": "Explore Dakota Ridge in Williston, ND through our virtual tour experience. See layouts and community atmosphere from anywhere.",
  "property_seo_title_interactivemap": "Interactive Map | Dakota Ridge Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Dakota Ridge in Williston, ND. Enjoy spacious two and three-bedroom apartments, a pet-friendly community, and top-notch amenities!",
  "property_seo_title_neighborhood": "Neighborhood | Dakota Ridge | Williston, ND",
  "property_seo_description_neighborhood": "Live near Eagle Ridge Golf Course, shopping, parks, and great restaurants at Dakota Ridge in Williston, ND.",
  "property_seo_title_contact": "Contact the Dakota Ridge Leasing Team | Williston, ND",
  "property_seo_description_contact": "Contact the Dakota Ridge Apartments team in Williston, ND, with questions or to schedule a visit. Leasing info available.",
  "property_seo_title_faqs": "FAQs | Apartments in Williston, ND",
  "property_seo_description_faqs": "Uncover the ins and outs of Dakota Ridge in Williston, ND. Get answers to your burning questions about our pet-friendly community and top-tier amenities!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Williston, ND",
  "property_seo_description_reviews": "Join the Dakota Ridge community in Williston, ND! Check out resident reviews and see why our pet-friendly apartments and premium amenities feel like home.",
  "property_seo_title_applynow": "Apply Now | Apartments in Williston, ND",
  "property_seo_description_applynow": "Discover vibrant living at Dakota Ridge in Williston, ND. Enjoy spacious floor plans, great amenities, and a pet-friendly atmosphere!",
  "property_seo_title_residentaccess": "Resident Access | Dakota Ridge",
  "property_seo_description_residentaccess": "Login to Dakota Ridge's resident portal for easy rent payments, maintenance requests, and community updates—all in one convenient place!",
  "property_seo_title_referafriend": "Refer A Friend | Dakota Ridge",
  "property_seo_description_referafriend": "Great friends make great neighbors at Dakota Ridge! Refer a friend today and unlock the door to an amazing living experience in Williston, ND.",
  "property_seo_title_scheduletour": "Schedule a Tour | Dakota Ridge | Williston, ND",
  "property_seo_description_scheduletour": "Tour Dakota Ridge apartments in Williston, ND. Choose your way to see our community - virtual or in-person options available.",
  "property_seo_title_privacy": "Privacy Policy | Dakota Ridge",
  "property_seo_description_privacy": "At Dakota Ridge in Williston, ND, your privacy matters. Read our privacy policy to see how we protect your information while you enjoy your home.",
  "property_seo_title_accessibility": "Website Accessibility | Dakota Ridge",
  "property_seo_description_accessibility": "At Dakota Ridge in Williston, ND, we prioritize digital inclusion and accessibility for all. Join our community where everyone feels at home and connected.",
  "property_seo_title_sitemap": "Sitemap | Dakota Ridge",
  "property_seo_description_sitemap": "Explore Dakota Ridge in Williston, ND! Use our sitemap to discover your ideal apartment and community features that fit your lifestyle.",
  "property_seo_title_thankyou": "Thank You | Dakota Ridge",
  "property_seo_description_thankyou": "Thank you for reaching out to Dakota Ridge in Williston, ND! A team member will connect with you soon to assist you in finding your perfect home.",
  "property_seo_title_pets": "Pet Policy | Apartments in Williston, ND",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791842253897",
  "amenities": [
    {
      "id": "ec_7382d56f92d02f2646b45bf4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "source": "yardi",
      "external_id": "86288276",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5693657831178240/019d99d3-58cd-760d-9548-92abe79ff330.webp",
      "amenity_image_media": {
        "alt_text": "Gym with treadmills, ellipticals, weight machines, and benches.",
        "public_id": "019d99d3-58cd-760d-9548-92abe79ff330",
        "storage_key": "property/5693657831178240/019d99d3-58cd-760d-9548-92abe79ff330.webp",
        "width": 2560,
        "height": 1707
      },
      "amenity_image_alt_text": "Dakota Ridge Fitness Center Apartments for Rent with indoor gym Williston, ND,",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1fff84ce72b55dd163a5bf22",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "source": "yardi",
      "external_id": "86288282",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5693657831178240/019d99d3-53b2-754e-8dc8-1c567e451d25.webp",
      "amenity_image_media": {
        "alt_text": "Business center with two computers and magazine rack",
        "public_id": "019d99d3-53b2-754e-8dc8-1c567e451d25",
        "storage_key": "property/5693657831178240/019d99d3-53b2-754e-8dc8-1c567e451d25.webp",
        "width": 2560,
        "height": 1707
      },
      "amenity_image_alt_text": "Dakota Ridge business Center Apartments for Rent with work space Williston, ND",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c99b31f2c5c3a331a7c57ec6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "source": "yardi",
      "external_id": "86288228",
      "title": "BBQ Grills",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5693657831178240/019d99d3-5474-73eb-a396-1a418acb0f1b.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor patio with tables, chairs, and grill, with apartment buildings in the background.",
        "public_id": "019d99d3-5474-73eb-a396-1a418acb0f1b",
        "storage_key": "property/5693657831178240/019d99d3-5474-73eb-a396-1a418acb0f1b.webp",
        "width": 2560,
        "height": 1707
      },
      "amenity_image_alt_text": "Dakota Ridge BBQ Area Williston ND Apartments for rent,Dakota Ridge Playground Apartments for Rent with outdoor playground Williston, ND",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1e5f4850b09bed6d0c53620b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "source": "yardi",
      "external_id": "86288283",
      "title": "On-site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0bec6ab58352caf902812e47",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "source": "yardi",
      "external_id": "86288275",
      "title": "Resident Lounge with Entertainment Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5693657831178240/019d01a0-784e-728c-af2f-a7303cbed09b.webp",
      "amenity_image_media": {
        "alt_text": "Spacious, well-lit lobby with seating areas and large windows.",
        "public_id": "019d01a0-784e-728c-af2f-a7303cbed09b",
        "storage_key": "property/5693657831178240/019d01a0-784e-728c-af2f-a7303cbed09b.webp",
        "width": 1000,
        "height": 654
      },
      "amenity_image_alt_text": ",,,",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_179927b37962b7a7fe358362",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "source": "yardi",
      "external_id": "86288229",
      "title": "Game Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5693657831178240/019d01a0-7439-752d-8431-83b5c5c4db74.webp",
      "amenity_image_media": {
        "alt_text": "Billiard table in the community lounge area with seating and a TV.",
        "public_id": "019d01a0-7439-752d-8431-83b5c5c4db74",
        "storage_key": "property/5693657831178240/019d01a0-7439-752d-8431-83b5c5c4db74.webp",
        "width": 2560,
        "height": 1707
      },
      "amenity_image_alt_text": "Dakota Ridge Game Room Williston ND Apartments for rent",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d6f8966e6bb30222b956bd87",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "source": "yardi",
      "external_id": "86288277",
      "title": "Large Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5693657831178240/019d01a0-72c7-7579-a384-6cec3f6e0cb6.webp",
      "amenity_image_media": {
        "alt_text": "Apartment buildings with a large green lawn and picnic areas.",
        "public_id": "019d01a0-72c7-7579-a384-6cec3f6e0cb6",
        "storage_key": "property/5693657831178240/019d01a0-72c7-7579-a384-6cec3f6e0cb6.webp",
        "width": 1000,
        "height": 571
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_337f99659563dd39d7ccca54",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "source": "yardi",
      "external_id": "86288278",
      "title": "Pet-friendly",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5693657831178240/019d01a0-6ff9-77f1-b973-8ace5fa4cada.webp",
      "amenity_image_media": {
        "alt_text": "Apartment buildings with a large green lawn and picnic tables.",
        "public_id": "019d01a0-6ff9-77f1-b973-8ace5fa4cada",
        "storage_key": "property/5693657831178240/019d01a0-6ff9-77f1-b973-8ace5fa4cada.webp",
        "width": 1236,
        "height": 750
      },
      "amenity_image_alt_text": "Dakota Ridge Property View",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5b7522ae82f8a18cda63fcb2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "source": "yardi",
      "external_id": "86288250",
      "title": "Oversized Two-Car Garages*",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5693657831178240/019d01a0-7ca1-716f-b651-0ef5f25a8b33.webp",
      "amenity_image_media": {
        "alt_text": "Row of storage unit garage doors",
        "public_id": "019d01a0-7ca1-716f-b651-0ef5f25a8b33",
        "storage_key": "property/5693657831178240/019d01a0-7ca1-716f-b651-0ef5f25a8b33.webp",
        "width": 2560,
        "height": 1707
      },
      "amenity_image_alt_text": "Dakota Ridge Parking Garage Williston ND Apartments for rent",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1d267e424ee77327dd9aa37a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "source": "yardi",
      "external_id": "86288274",
      "title": "Walking Paths",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4758c207bfeed51f61323108",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "source": "yardi",
      "external_id": "86288279",
      "title": "Electrical Outlets in Parking for Block Heaters",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ae6fef12d7d07d3a9e6c81f9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "source": "yardi",
      "external_id": "86288223",
      "title": "Online Payments Available",
      "amount": "false",
      "description": "Free e-check option\r\nAccepts credit card payments\r\nAccepts cash payments via MoneyGram",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c8ac8a7667d3a2c8c4e0fc51",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "source": "yardi",
      "external_id": "124800031",
      "title": "Smoke Free",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_80b8bcb6c93252f5886f142a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "source": "yardi",
      "external_id": "86288287",
      "title": "Ceiling Fan*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5693657831178240/019d99d3-5349-71d0-b805-8f795ccd2fc6.webp",
      "amenity_image_media": {
        "alt_text": "Bedroom with a queen-size bed, ceiling fan, and nightstand.",
        "public_id": "019d99d3-5349-71d0-b805-8f795ccd2fc6",
        "storage_key": "property/5693657831178240/019d99d3-5349-71d0-b805-8f795ccd2fc6.webp",
        "width": 1000,
        "height": 679
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f90ed5f4b6262f25f5c9c2cb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "source": "yardi",
      "external_id": "86288288",
      "title": "Vaulted Ceiling*",
      "amount": "false",
      "description": "Only on 3rd floor",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5693657831178240/019d99d3-51c7-73ce-835c-807efdc68dff.webp",
      "amenity_image_media": {
        "alt_text": "Bedroom with a large closet.",
        "public_id": "019d99d3-51c7-73ce-835c-807efdc68dff",
        "storage_key": "property/5693657831178240/019d99d3-51c7-73ce-835c-807efdc68dff.webp",
        "width": 2560,
        "height": 1707
      },
      "amenity_image_alt_text": "Dakota Ridge Master Bedroom Williston ND Apartments for rent",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_123c63c7a97fe25e010249aa",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "source": "yardi",
      "external_id": "86288290",
      "title": "Wood Style Flooring",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5693657831178240/019d99d3-6c73-76dd-b4e6-58d71fd4c618.webp",
      "amenity_image_media": {
        "alt_text": "Living room with vaulted ceiling, exposed beam, sofa, loveseat, coffee table, TV, and dining area.",
        "public_id": "019d99d3-6c73-76dd-b4e6-58d71fd4c618",
        "storage_key": "property/5693657831178240/019d99d3-6c73-76dd-b4e6-58d71fd4c618.webp",
        "width": 1000,
        "height": 750
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e30ac1d126fce45b83ac5888",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "source": "yardi",
      "external_id": "86288291",
      "title": "Full Sized Washer and Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5693657831178240/019d99d3-729a-7391-b14c-33c576321ff7.webp",
      "amenity_image_media": {
        "alt_text": "Laundry room with washer and dryer",
        "public_id": "019d99d3-729a-7391-b14c-33c576321ff7",
        "storage_key": "property/5693657831178240/019d99d3-729a-7391-b14c-33c576321ff7.webp",
        "width": 2560,
        "height": 1707
      },
      "amenity_image_alt_text": "Dakota Ridge washer/dryer Apartments for Rent Williston, ND",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_67fe5d51d80c9673512c5f5b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "source": "yardi",
      "external_id": "86288292",
      "title": "Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5693657831178240/019d99d3-7a5c-758e-aed0-26df5ce6788f.webp",
      "amenity_image_media": {
        "alt_text": "Exterior of apartment building with path and landscaping.",
        "public_id": "019d99d3-7a5c-758e-aed0-26df5ce6788f",
        "storage_key": "property/5693657831178240/019d99d3-7a5c-758e-aed0-26df5ce6788f.webp",
        "width": 2560,
        "height": 1707
      },
      "amenity_image_alt_text": "Dakota Ridge Patio Williston ND Apartments for rent",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fde112df58d8bcd14c0d2ea8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "source": "yardi",
      "external_id": "86288294",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6f22c3d57a250602c91b32d1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "source": "yardi",
      "external_id": "86288286",
      "title": "Black Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5693657831178240/019d01a0-7f9b-71cc-9cea-04c5c9955817.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, stainless steel appliances, and a tiled backsplash.",
        "public_id": "019d01a0-7f9b-71cc-9cea-04c5c9955817",
        "storage_key": "property/5693657831178240/019d01a0-7f9b-71cc-9cea-04c5c9955817.webp",
        "width": 2560,
        "height": 1707
      },
      "amenity_image_alt_text": "Dakota Ridge kitchen Apartments for Rent Williston, ND",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_aae6268383b68b17169983c7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "source": "yardi",
      "external_id": "86288284",
      "title": "Double Vanities",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5693657831178240/019d01a0-837b-7681-8d23-7f9533dccdb9.webp",
      "amenity_image_media": {
        "alt_text": "Bathroom with double vanity and built-in shelving.",
        "public_id": "019d01a0-837b-7681-8d23-7f9533dccdb9",
        "storage_key": "property/5693657831178240/019d01a0-837b-7681-8d23-7f9533dccdb9.webp",
        "width": 2560,
        "height": 1707
      },
      "amenity_image_alt_text": "Dakota Ridge Master Bathroom Apartments for Rent Williston, ND",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c9fc41c6d00a1881ccb3c115",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "source": "yardi",
      "external_id": "86288289",
      "title": "Granite countertops*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5693657831178240/019d01a0-835a-7136-bf7c-fff84667d3fa.webp",
      "amenity_image_media": {
        "alt_text": "Bathroom with toilet, sink, and shower curtain.",
        "public_id": "019d01a0-835a-7136-bf7c-fff84667d3fa",
        "storage_key": "property/5693657831178240/019d01a0-835a-7136-bf7c-fff84667d3fa.webp",
        "width": 2560,
        "height": 1707
      },
      "amenity_image_alt_text": "Dakota Ridge Bathroom Williston ND Apartments for rent,Dakota Ridge kitchen Apartments for Rent Williston, ND",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_301a4b7362cd219d096a0b03",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "source": "yardi",
      "external_id": "86288285",
      "title": "Built In Desks",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_d06c692800ee115d98f6718f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5693657831178240/019d019f-f9c4-714d-9404-f5f8cb6911fc.webp",
      "image_media": {
        "alt_text": "Living room with a light gray sofa, coffee table, and TV.",
        "public_id": "019d019f-f9c4-714d-9404-f5f8cb6911fc",
        "storage_key": "property/5693657831178240/019d019f-f9c4-714d-9404-f5f8cb6911fc.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a comfortable sofa, a modern coffee table, and a mounted TV, perfect for relaxation and entertainment.",
      "link": "false",
      "alt_text": "Living room with a light gray sofa, coffee table, and TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/ND_Dakota_Ridge_Favorites (1).jpg"
    },
    {
      "id": "ec_e1f9ad67d051e3438e70c3b7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5693657831178240/019d01a0-0a3a-74d8-89b9-ea9227c8b997.webp",
      "image_media": {
        "alt_text": "Modern kitchen with wood cabinets, granite countertops, and black appliances.",
        "public_id": "019d01a0-0a3a-74d8-89b9-ea9227c8b997",
        "storage_key": "property/5693657831178240/019d01a0-0a3a-74d8-89b9-ea9227c8b997.webp",
        "width": 3072,
        "height": 2222
      },
      "title": "Apartment",
      "description": "Stylish kitchen featuring rich wood cabinetry, sleek granite countertops, a decorative tile backsplash, and modern stainless steel appliances for a comfortable living experience.",
      "link": "false",
      "alt_text": "Modern kitchen with wood cabinets, granite countertops, and black appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/ND_Dakota_Ridge_Favorites (2).jpg"
    },
    {
      "id": "ec_d3190d7bb7e8d3591b6dc815",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5693657831178240/019d019f-f9c4-714d-9404-fccaffb0d4c6.webp",
      "image_media": {
        "alt_text": "Bedroom with a closet",
        "public_id": "019d019f-f9c4-714d-9404-fccaffb0d4c6",
        "storage_key": "property/5693657831178240/019d019f-f9c4-714d-9404-fccaffb0d4c6.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "A spacious bedroom featuring a comfortable bed, nightstand, and a large closet with shelving and hanging space.",
      "link": "false",
      "alt_text": "Bedroom with a closet",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/ND_Dakota_Ridge_Favorites (3).jpg"
    },
    {
      "id": "ec_4be1a5c34fdc69db19cce23d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5693657831178240/019d01a0-0f8e-7229-9a63-738404059699.webp",
      "image_media": {
        "alt_text": "Bathroom with double vanity, toilet, and shower with tub.",
        "public_id": "019d01a0-0f8e-7229-9a63-738404059699",
        "storage_key": "property/5693657831178240/019d01a0-0f8e-7229-9a63-738404059699.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Apartment",
      "description": "Bright and clean bathroom featuring a double vanity with granite countertops, a toilet, and a shower/tub combination.",
      "link": "false",
      "alt_text": "Bathroom with double vanity, toilet, and shower with tub.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/ND_Dakota_Ridge_Favorites (4).jpg"
    },
    {
      "id": "ec_67c8094a3ed719a8808c3663",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5693657831178240/019d01a0-0f29-75fd-a7f1-71a2237ba8ec.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed and two windows.",
        "public_id": "019d01a0-0f29-75fd-a7f1-71a2237ba8ec",
        "storage_key": "property/5693657831178240/019d01a0-0f29-75fd-a7f1-71a2237ba8ec.webp",
        "width": 3072,
        "height": 2303
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a queen-size bed with decorative pillows and two large windows offering scenic views.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed and two windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/ND_Dakota_Ridge_Favorites (5).jpg"
    },
    {
      "id": "ec_abb289b1ee70bf385166a59d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5693657831178240/019d01a0-1b71-727c-ad3a-a1dcc185b8cc.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, weight machines, and free weights.",
        "public_id": "019d01a0-1b71-727c-ad3a-a1dcc185b8cc",
        "storage_key": "property/5693657831178240/019d01a0-1b71-727c-ad3a-a1dcc185b8cc.webp",
        "width": 3072,
        "height": 2303
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring cardio machines and strength training equipment.",
      "link": "false",
      "alt_text": "Fitness center with treadmills, weight machines, and free weights.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/ND_Dakota_Ridge_Favorites (6).jpg"
    },
    {
      "id": "ec_8aa28df91b461cb2f7d5fb7c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5693657831178240/019d01a0-3576-7490-938b-43a7c504b755.webp",
      "image_media": {
        "alt_text": "Spacious communal lounge area with a large sectional sofa, fireplace, and seating.",
        "public_id": "019d01a0-3576-7490-938b-43a7c504b755",
        "storage_key": "property/5693657831178240/019d01a0-3576-7490-938b-43a7c504b755.webp",
        "width": 3072,
        "height": 2129
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed communal lounge, featuring a cozy fireplace and ample comfortable seating for residents.",
      "link": "false",
      "alt_text": "Spacious communal lounge area with a large sectional sofa, fireplace, and seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/ND_Dakota_Ridge_Favorites (7).jpg"
    },
    {
      "id": "ec_e3d91afaff001f2f1597f60f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5693657831178240/019d01a0-41de-70c5-b35c-9734e5fd1c2f.webp",
      "image_media": {
        "alt_text": "Outdoor patio with tables, chairs, and a grill, overlooking a grassy lawn and apartment buildings.",
        "public_id": "019d01a0-41de-70c5-b35c-9734e5fd1c2f",
        "storage_key": "property/5693657831178240/019d01a0-41de-70c5-b35c-9734e5fd1c2f.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Enjoy outdoor gatherings on the patio, complete with grilling stations and comfortable seating, set against a backdrop of scenic community grounds and modern apartment buildings.",
      "link": "false",
      "alt_text": "Outdoor patio with tables, chairs, and a grill, overlooking a grassy lawn and apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/ND_Dakota_Ridge_Favorites (8).jpg"
    },
    {
      "id": "ec_3d98e88b0a2b4145a2295390",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5693657831178240/019d01a0-48f1-766e-87c7-3db316a30ef7.webp",
      "image_media": {
        "alt_text": "Dakota Ridge Apartment Homes building exterior with entrance and parking lot.",
        "public_id": "019d01a0-48f1-766e-87c7-3db316a30ef7",
        "storage_key": "property/5693657831178240/019d01a0-48f1-766e-87c7-3db316a30ef7.webp",
        "width": 3072,
        "height": 2088
      },
      "title": "Community",
      "description": "Exterior view of the Dakota Ridge Apartment Homes clubhouse and leasing office on a sunny day, showcasing the entrance and surrounding landscaping.",
      "link": "false",
      "alt_text": "Dakota Ridge Apartment Homes building exterior with entrance and parking lot.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/ND_Dakota_Ridge_Favorites (9).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_a61ad008-55a1-4127-bb12-57d1fc3d2c7c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "source": "custom",
      "poi_name": "Los Cabos Family Mexican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "7117 2nd Ave W, Williston, ND 58801, USA",
      "poi_short_description": "Casual Mexican haunt serving up burritos, fajitas, and other classics, plus margaritas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5693657831178240/019d01a0-ea60-705c-a19c-d9f5883efa5b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-ea60-705c-a19c-d9f5883efa5b",
        "storage_key": "property/5693657831178240/019d01a0-ea60-705c-a19c-d9f5883efa5b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.loscaboswilliston.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6540848487752189092",
      "poi_item_slug": "los-cabos-family-mexican-restaurant",
      "poi_latitude": "48.214211",
      "poi_longitude": "-103.6269296",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 701-609-5977",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5693657831178240/019d01a0-f993-7181-b260-7414e2aca541.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-f993-7181-b260-7414e2aca541",
        "storage_key": "property/5693657831178240/019d01a0-f993-7181-b260-7414e2aca541.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJOTLVMgBdIVMRpMQecgvDxVo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_b4cd89bf-58d7-43a2-a5ab-b3c7dd4ace70",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "source": "custom",
      "poi_name": "Dark Acres Halloween",
      "poi_type": "Shopping & Retail",
      "poi_address": "5208 2nd Ave W Apt B, Williston, ND 58801, USA",
      "poi_short_description": "Store featuring Halloween costumes, masks, makeup, decorations, and more.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5693657831178240/019d01a0-ea4a-74d9-b7b8-722c11ba61e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-ea4a-74d9-b7b8-722c11ba61e3",
        "storage_key": "property/5693657831178240/019d01a0-ea4a-74d9-b7b8-722c11ba61e3.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.facebook.com/darkacres",
      "poi_directions_map_url": "https://maps.google.com/?cid=290750653330711711",
      "poi_item_slug": "dark-acres-halloween",
      "poi_latitude": "48.1921127",
      "poi_longitude": "-103.6247112",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 701-770-2567",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5693657831178240/019d01a0-f9bc-7006-aaa7-1f2cf90a3874.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-f9bc-7006-aaa7-1f2cf90a3874",
        "storage_key": "property/5693657831178240/019d01a0-f9bc-7006-aaa7-1f2cf90a3874.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJAQAAAGFbIVMRn2T9wS30CAQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_baf3dc11-843a-4c48-a63a-9d44c426264c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "source": "custom",
      "poi_name": "Missouri Ridge School",
      "poi_type": "Education",
      "poi_address": "5640 140th Ave NW, Williston, ND 58801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.willistonschools.org/o/missouri-ridge",
      "poi_directions_map_url": "https://maps.google.com/?cid=8259799661957318937",
      "poi_item_slug": "missouri-ridge-school",
      "poi_latitude": "48.2329719",
      "poi_longitude": "-103.7106522",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 701-875-2041",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5693657831178240/019d01a0-f993-7181-b260-7db18072bdab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-f993-7181-b260-7db18072bdab",
        "storage_key": "property/5693657831178240/019d01a0-f993-7181-b260-7db18072bdab.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ5UOXqytnIVMRGYnbvge0oHI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_0fe9706e-e8ca-4993-87cd-84f8611a146b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "source": "custom",
      "poi_name": "The Frontier Museum",
      "poi_type": "Entertainment",
      "poi_address": "6330 1st Ave W, Williston, ND 58801, USA",
      "poi_short_description": "Visitors can tour a general store, school & church depicting local history since the 19th century.",
      "poi_long_description": "Visitors can tour a general store, school & church depicting local history since the 19th century.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5693657831178240/019d01a0-e9d1-7118-8228-d54fdab150c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-e9d1-7118-8228-d54fdab150c4",
        "storage_key": "property/5693657831178240/019d01a0-e9d1-7118-8228-d54fdab150c4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.thefrontiermuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1268479469001247800",
      "poi_item_slug": "the-frontier-museum",
      "poi_latitude": "48.203693",
      "poi_longitude": "-103.624705",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 701-580-2415",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5693657831178240/019d01a0-f993-7181-b260-789e28cfcd6f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-f993-7181-b260-789e28cfcd6f",
        "storage_key": "property/5693657831178240/019d01a0-f993-7181-b260-789e28cfcd6f.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ57DnzNdIVMROAyyOluLmhE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_762a0fbc-f590-42d2-b99b-51d6ab4c64ae",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "source": "custom",
      "poi_name": "Kritterz Veterinary Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "7010 1st Ave W, Williston, ND 58801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5693657831178240/019d01a0-ee57-70ea-8783-b176f37fad80.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-ee57-70ea-8783-b176f37fad80",
        "storage_key": "property/5693657831178240/019d01a0-ee57-70ea-8783-b176f37fad80.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7573044261662267821",
      "poi_item_slug": "kritterz-veterinary-hospital",
      "poi_latitude": "48.21338979999999",
      "poi_longitude": "-103.6251837",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 701-774-7979",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5693657831178240/019d01a0-fc74-7468-b838-6a090ebd073c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-fc74-7468-b838-6a090ebd073c",
        "storage_key": "property/5693657831178240/019d01a0-fc74-7468-b838-6a090ebd073c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR5nbh79cIVMRrZmw3KHbGGk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_0cdc636d-9614-4e95-9d43-7a20c2cd5960",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "source": "custom",
      "poi_name": "Skylaa Nail Bar (Body waxing )",
      "poi_type": "Health and Wellness",
      "poi_address": "124 51st St W, Williston, ND 58801, USA",
      "poi_short_description": "Nail salon offering manicures, pedicures, waxing, eyelash extensions, and haircuts, as well as a coffee bar and boba cafe.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5693657831178240/019d01a0-ee32-7569-9fe6-871d0ee013d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-ee32-7569-9fe6-871d0ee013d6",
        "storage_key": "property/5693657831178240/019d01a0-ee32-7569-9fe6-871d0ee013d6.webp",
        "width": 985,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14424046258636364999",
      "poi_item_slug": "skylaa-nail-bar-body-waxing-",
      "poi_latitude": "48.1914782",
      "poi_longitude": "-103.6251583",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 701-609-5229",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5693657831178240/019d01a0-fc74-7468-b838-6a090ebd073c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-fc74-7468-b838-6a090ebd073c",
        "storage_key": "property/5693657831178240/019d01a0-fc74-7468-b838-6a090ebd073c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX-YNUMZdIVMRx5zSfaaBLMg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_5adfab35-fed1-4a12-bc02-2301c7afef16",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "source": "custom",
      "poi_name": "Spring Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5906 2nd Ave W, Williston, ND 58801, USA",
      "poi_short_description": "Park offering a disc golf course, picnic, and play areas, plus volleyball and fishing.",
      "poi_long_description": "Visitors say this park is a great place for fishing, with a fishing platform over by the boat ramp that is a good fishing spot. They also highlight that it's a beautiful park that's great for swimming, playing, and enjoying the outdoors.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5693657831178240/019d01a0-efa4-7568-9e4a-a8ea320d7d9f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-efa4-7568-9e4a-a8ea320d7d9f",
        "storage_key": "property/5693657831178240/019d01a0-efa4-7568-9e4a-a8ea320d7d9f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.willistonparks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9677238210427773620",
      "poi_item_slug": "spring-lake-park",
      "poi_latitude": "48.2018042",
      "poi_longitude": "-103.618575",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 701-774-9773",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5693657831178240/019d01a0-fca2-75c9-8b69-809e76d571b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-fca2-75c9-8b69-809e76d571b3",
        "storage_key": "property/5693657831178240/019d01a0-fca2-75c9-8b69-809e76d571b3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ6J6tDJdIVMRtGJiU-F0TIY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_a0a1340b-1070-439b-8ce0-8b89bce4b408",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "source": "custom",
      "poi_name": "Eagle Ridge Golf Club",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6401 3rd Ave E Suite 1, Williston, ND 58801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5693657831178240/019d01a0-efe9-70ec-8f95-2a220078aeed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-efe9-70ec-8f95-2a220078aeed",
        "storage_key": "property/5693657831178240/019d01a0-efe9-70ec-8f95-2a220078aeed.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://eagleridgewilliston.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10920535095398698400",
      "poi_item_slug": "eagle-ridge-golf-club",
      "poi_latitude": "48.2039772",
      "poi_longitude": "-103.6093962",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 701-572-6500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5693657831178240/019d01a0-fcab-7038-8035-c468c7112917.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-fcab-7038-8035-c468c7112917",
        "storage_key": "property/5693657831178240/019d01a0-fcab-7038-8035-c468c7112917.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJdWfz_5ZdIVMRoA1tTs-IjZc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_e8de9cea-6ecc-4271-ad09-a31f3b03cd9f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "source": "custom",
      "poi_name": "Missouri Ridge Commercial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "13551 Hamilton Ln, Williston, ND 58801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5693657831178240/019d01a0-f3f1-74be-8a56-45a59e6870d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-f3f1-74be-8a56-45a59e6870d9",
        "storage_key": "property/5693657831178240/019d01a0-f3f1-74be-8a56-45a59e6870d9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15481500306547554601",
      "poi_item_slug": "missouri-ridge-commercial-park",
      "poi_latitude": "48.2595792",
      "poi_longitude": "-103.6164399",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5693657831178240/019d01a0-fca2-75c9-8b69-809e76d571b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-fca2-75c9-8b69-809e76d571b3",
        "storage_key": "property/5693657831178240/019d01a0-fca2-75c9-8b69-809e76d571b3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJtT7FgkNoIVMRKTneGYFW2dY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_00450092-8c36-4053-843d-3b44f6105082",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "source": "custom",
      "poi_name": "Williston Basin International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "14127 Jensen Ln, Williston, ND 58801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5693657831178240/019d01a0-f426-704c-a425-dbca4234feeb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-f426-704c-a425-dbca4234feeb",
        "storage_key": "property/5693657831178240/019d01a0-f426-704c-a425-dbca4234feeb.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.flywilliston.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7027633441429145880",
      "poi_item_slug": "williston-basin-international-airport",
      "poi_latitude": "48.2578206",
      "poi_longitude": "-103.7417095",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 701-875-8594",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5693657831178240/019d01a0-fd3d-739e-8b8f-b06e48fd61c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-fd3d-739e-8b8f-b06e48fd61c3",
        "storage_key": "property/5693657831178240/019d01a0-fd3d-739e-8b8f-b06e48fd61c3.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJi4mULFpnIVMRGEkKiGErh2E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_c0ce9c02-99a6-4716-b24e-48f9eb9f2bc9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "source": "custom",
      "poi_name": "Overland Aviation",
      "poi_type": "Transportation & Transit",
      "poi_address": "14151 Commerce Dr, Williston, ND 58801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5693657831178240/019d01a0-f50a-727c-b58d-2e33ca48b3b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-f50a-727c-b58d-2e33ca48b3b5",
        "storage_key": "property/5693657831178240/019d01a0-f50a-727c-b58d-2e33ca48b3b5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.overlandaviation.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1404420488366858165",
      "poi_item_slug": "overland-aviation",
      "poi_latitude": "48.2658363",
      "poi_longitude": "-103.7491018",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 701-875-4334",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5693657831178240/019d01a0-fd3d-739e-8b8f-b06e48fd61c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-fd3d-739e-8b8f-b06e48fd61c3",
        "storage_key": "property/5693657831178240/019d01a0-fd3d-739e-8b8f-b06e48fd61c3.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJt4eFDMNcIVMRtR9jRP6AfRM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_1ffbfae7-af00-4f5f-b698-21f3e23a1081",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "source": "custom",
      "poi_name": "Spydr Oilfield Service",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5309 Saddle Ridge Cir Unit F, Williston, ND 58801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5693657831178240/019d01a0-f5f1-713f-8576-a376b241e129.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-f5f1-713f-8576-a376b241e129",
        "storage_key": "property/5693657831178240/019d01a0-f5f1-713f-8576-a376b241e129.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=18433282211163594255",
      "poi_item_slug": "spydr-oilfield-service",
      "poi_latitude": "48.1930625",
      "poi_longitude": "-103.6616936",
      "poi_miles_from_property": "8.6",
      "poi_walking_minutes": "3 hours 8 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 701-774-2340",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5693657831178240/019d01a0-fc74-7468-b838-6a090ebd073c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-fc74-7468-b838-6a090ebd073c",
        "storage_key": "property/5693657831178240/019d01a0-fc74-7468-b838-6a090ebd073c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7W5oqwVdIVMRD97u4IEs0P8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_5ac2cc93f892dc692958a303",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_d344ddc2c7f9e09801e5e13c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_6ad6316952378c348fe33dea",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_bffef5926eea4f9e37c821c7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_e5d600fde1445aa4569f08bc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_39096673-a26f-4725-94c3-587814b645b7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "rating": "5.0",
      "name": "Tangie Smith",
      "text": "Being that im new to the area from Florida i would like to acknowledge a couple ladiesne HANDS DOWN MELISSA  is the absolute best she was very transparent very very polite, informative and most of all professional Although  Dakota Ridge is awesome cause they are so far Melissa is the reason I decided choose this place!Also I had the pleasure of meeting Shelly at Renaissance Heights she was also phenomenal so very helpful even when she couldn't help me there she directed me to Melissa.  Thanks for the warm welcoming u ladies ROCK!!! ❤️",
      "date": "2026-01-23",
      "title": "false"
    },
    {
      "id": "custom_6d0f33a4-1f1d-4fe0-8b1b-238bc92a0fd9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "rating": "5.0",
      "name": "George Wright",
      "text": "I met with Shelly, the Assistant Community Director from Renaissance Hights Apartment Homes, she was being a team player and helping her colleagues at a sister property, she was super friendly and very helpful, she helped me fill out the application and explained everything clearly, she helped me to understand the difference between the floor plans, the prices and even between the different sister properties\n\nThank You Shelly🙏🙏",
      "date": "2025-10-21",
      "title": "false"
    },
    {
      "id": "custom_39174b43-4fdf-4fc2-933e-3cd4feee740b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "rating": "5.0",
      "name": "Norcal Girl",
      "text": "Best apartments in Williston!\nWeidner is definitely the only place I would recommend if you have to choose an apartment- most are really nice.",
      "date": "2025-08-31",
      "title": "false"
    },
    {
      "id": "custom_d61deb6c-0d00-4df3-bffb-787a262fc3b0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "rating": "5.0",
      "name": "Arturo Hinojos",
      "text": "Hola, just wanted to appreciate Cali and her staff for the great experience on having everything we need in our apartment. Thanks again.  Also want to appreciate the maintenance on a  fast response to fixing the washer machine. Very appreciated. 👍",
      "date": "2025-04-03",
      "title": ""
    },
    {
      "id": "custom_bd7bf3db-1271-4513-85cc-1b8c90d9bb16",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "rating": "5.0",
      "name": "Rachel J",
      "text": "First off, I want to give a huge shout out to Cameron, She went above and beyond to grab my work equipment that was accidentally sent before I moved there. My apartment is beautiful, Granite counters top quality appliances, They make big accommodations for pet parents. There is an awesome gym and they even go the extra mile by putting cold water in the fridge in there. A lot of little extras and move in was easy and simple. It's a few miles outside a town which I love surrounded by lush farmlands. And the neighbors are all awesome. And added plus the walls are very thick and you can't hear your neighbors. You definitely wanna live here‼️‼️‼️",
      "date": "2024-06-12",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_77cbe5556c66c72c3f18abf5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5693657831178240/019ddcc4-6efb-7110-a2dc-56a21a2c1706.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddcc4-6efb-7110-a2dc-56a21a2c1706",
        "storage_key": "property/5693657831178240/019ddcc4-6efb-7110-a2dc-56a21a2c1706.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Pike",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=xG81J46LwLb"
    },
    {
      "id": "ec_bce90ce2377991ceaa6844af",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5693657831178240/019ddcc4-6e19-74c3-b98d-84694a424e0b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddcc4-6e19-74c3-b98d-84694a424e0b",
        "storage_key": "property/5693657831178240/019ddcc4-6e19-74c3-b98d-84694a424e0b.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "White Butte",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=58hrYixyWwK"
    },
    {
      "id": "ec_0eacf8d581ccf284c9fdc4e2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5693657831178240/019ddcc4-6e07-7597-8486-dab68393e23f.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddcc4-6e07-7597-8486-dab68393e23f",
        "storage_key": "property/5693657831178240/019ddcc4-6e07-7597-8486-dab68393e23f.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Toboggan",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=gxPfxP7E6ZB"
    },
    {
      "id": "ec_058ceb7640fab770f7b00930",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5693657831178240/019ddcc4-6e21-751c-9fa6-22bdfcee6afb.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddcc4-6e21-751c-9fa6-22bdfcee6afb",
        "storage_key": "property/5693657831178240/019ddcc4-6e21-751c-9fa6-22bdfcee6afb.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Meadowlark",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=mdivARaVB7D"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa47-060f-77ce-a760-4590d5deb0d7",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "dakota-ridge",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240"
    },
    {
      "lead_collector_id": "0198aa47-0671-7079-865d-bc6de4a8eca0",
      "lead_source": "FACEBOOK_ADS",
      "name": "dakota-ridge",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240"
    },
    {
      "lead_collector_id": "0198aa47-06d6-72fa-b8e8-cc6e67a57983",
      "lead_source": "LANDING_PAGE",
      "name": "dakota-ridge",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-williston-nd",
      "search_query": "pet friendly apartments Williston ND",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments in Williston, ND",
      "h2_subtitle": "Discover the perfect pet-friendly living spaces in Williston, ND. Explore Dakota Ridge where pets are always welcome.",
      "page_copy": "Welcome to Dakota Ridge, your ideal destination for pet-friendly apartments in Williston, ND. Our community celebrates not just you, but your furry friends as well. With ample space in our two- and three-bedroom floor plans, we ensure every member of your family has room to thrive. Picture yourself in a cozy home with wood-style flooring, providing a comfortable surface for both you and your pets. \n\nAt Dakota Ridge, we know that your pets are part of the family. That's why we offer not only pet-friendly policies but also features like private balconies where you and your pets can enjoy the fresh air. Conveniently located in the North Dakota Area, Dakota Ridge combines modern convenience with the charm of Williams County, making it a perfect home base for pet owners. Schedule a tour today and see how our welcoming environment can cater to all family members, including the four-legged ones.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/5693657831178240/019d019f-f9c4-714d-9404-f5f8cb6911fc.webp",
      "featured_image_media": {
        "alt_text": "Living room with a light gray sofa, coffee table, and TV.",
        "public_id": "019d019f-f9c4-714d-9404-f5f8cb6911fc",
        "storage_key": "property/5693657831178240/019d019f-f9c4-714d-9404-f5f8cb6911fc.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments in Williston, ND",
      "seo_description": "Discover pet-friendly apartments in Williston, ND at Dakota Ridge. Modern living for you and your pets.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-williams-county",
      "search_query": "in unit laundry apartments Williams County",
      "category": "Amenity",
      "h1_title": "In-Unit Laundry Apartments in Williams County",
      "h2_subtitle": "Find your new home with in-unit laundry in Williams County. Dakota Ridge offers modern conveniences for an enhanced living experience.",
      "page_copy": "Experience the ease of having in-unit laundry at Dakota Ridge, perfectly situated in Williams County. Our spacious two- and three-bedroom apartments come equipped with full-size washers and dryers, offering unparalleled convenience right at home. Imagine the time saved and the comfort gained by taking care of laundry without leaving your apartment.\n\nDakota Ridge not only delivers practical amenities but does so while ensuring a comfortable lifestyle. Our community combines the charm of the North Dakota Area with the efficiency of modern living. In addition to in-unit laundry, you'll find features that enhance your daily living experience, like private balconies and wood-style flooring. Visit us today and see why Dakota Ridge is the go-to place for convenience in Williams County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/5693657831178240/019d019f-f9c4-714d-9404-f5f8cb6911fc.webp",
      "featured_image_media": {
        "alt_text": "Living room with a light gray sofa, coffee table, and TV.",
        "public_id": "019d019f-f9c4-714d-9404-f5f8cb6911fc",
        "storage_key": "property/5693657831178240/019d019f-f9c4-714d-9404-f5f8cb6911fc.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apts in Williams County",
      "seo_description": "Discover in-unit laundry apartments in Williams County at Dakota Ridge. Enjoy modern convenience in a spacious home.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "source": "generator",
      "page_item_url": "apartment-with-air-conditioning-north-dakota",
      "search_query": "apartment with air conditioning in North Dakota",
      "category": "Amenity",
      "h1_title": "Air-Conditioned Apartments in North Dakota",
      "h2_subtitle": "Stay cool with air-conditioned living spaces in North Dakota. Discover comfort at Dakota Ridge.",
      "page_copy": "Welcome to Dakota Ridge, where air-conditioned comfort meets modern living in North Dakota. Our thoughtfully designed two- and three-bedroom apartments offer the perfect retreat from the heat, with air conditioning ensuring a cool, comfortable home environment. Whether you're relaxing in the spacious living area or enjoying the view from your private balcony, comfort is always a priority.\n\nLocated in the welcoming community of the North Dakota Area, Dakota Ridge combines style with convenience. Beyond air conditioning, each apartment is equipped with amenities like full-size washers and dryers, and select units include vaulted ceilings for an airy feel. Experience the blend of modern design and essential comforts by scheduling a tour of Dakota Ridge today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/5693657831178240/019d019f-f9c4-714d-9404-f5f8cb6911fc.webp",
      "featured_image_media": {
        "alt_text": "Living room with a light gray sofa, coffee table, and TV.",
        "public_id": "019d019f-f9c4-714d-9404-f5f8cb6911fc",
        "storage_key": "property/5693657831178240/019d019f-f9c4-714d-9404-f5f8cb6911fc.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air-Conditioned Apartments in North Dakota",
      "seo_description": "Discover air-conditioned apartments in North Dakota at Dakota Ridge. Comfort and modern amenities in a spacious setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "source": "generator",
      "page_item_url": "apartments-with-dog-park-near-58801",
      "search_query": "apartments with dog park near 58801",
      "category": "Amenity",
      "h1_title": "Apartments with Dog Park Near 58801",
      "h2_subtitle": "Explore apartments featuring a dog park near the 58801 area. Dakota Ridge is a haven for you and your pets.",
      "page_copy": "Discover the ideal home for you and your furry friend at Dakota Ridge, where we offer apartments with access to a nearby dog park near the 58801 area. Our pet-friendly community in Williams County ensures that both you and your pets have the amenities you need to thrive, including spacious interiors and convenient locations.\n\nAt Dakota Ridge, we understand the joy pets bring and the importance of having spaces where they can play and explore. Our apartments are not only crafted for comfort and style, featuring wood-style flooring and vaulted ceilings, but they also accommodate the needs of pet owners. Choose Dakota Ridge and enjoy living in a place where both you and your pets can feel at home. Visit us today to learn more about our pet-friendly perks and environment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/5693657831178240/019d019f-f9c4-714d-9404-f5f8cb6911fc.webp",
      "featured_image_media": {
        "alt_text": "Living room with a light gray sofa, coffee table, and TV.",
        "public_id": "019d019f-f9c4-714d-9404-f5f8cb6911fc",
        "storage_key": "property/5693657831178240/019d019f-f9c4-714d-9404-f5f8cb6911fc.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts with Dog Park Near 58801",
      "seo_description": "Find apartments with access to a nearby dog park near 58801 at Dakota Ridge. Perfect for you and your furry friends.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "source": "generator",
      "page_item_url": "luxury-apartments-oversized-garages-williston",
      "search_query": "luxury apartments with oversized two-car garages Williston",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Oversized Garages",
      "h2_subtitle": "Discover luxury living with oversized two-car garages in Williston. Dakota Ridge offers the best in comfort and convenience.",
      "page_copy": "Experience the pinnacle of luxury living in Williston at Dakota Ridge, where our apartments boast oversized two-car garages, providing ample space and convenience. Perfect for those who value both elegance and functionality, these garages are tailored to accommodate all your storage and parking needs.\n\nInside, the luxury continues with spacious floor plans featuring modern amenities like full-size washers and dryers, vaulted ceilings, and private balconies. Dakota Ridge is not just a place to live—it's a lifestyle choice. Whether you're relaxing in your elegantly designed home or enjoying the vibrant community amenities like the game room, Dakota Ridge is where comfort meets style in Williston's luxury apartment scene.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/5693657831178240/019d019f-f9c4-714d-9404-f5f8cb6911fc.webp",
      "featured_image_media": {
        "alt_text": "Living room with a light gray sofa, coffee table, and TV.",
        "public_id": "019d019f-f9c4-714d-9404-f5f8cb6911fc",
        "storage_key": "property/5693657831178240/019d019f-f9c4-714d-9404-f5f8cb6911fc.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Garages in Williston",
      "seo_description": "Explore luxury apartments with oversized two-car garages at Dakota Ridge in Williston. Experience elegance and ample space.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-williston-nd",
      "search_query": "two bedroom apartments williston nd",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Williston, ND",
      "h2_subtitle": "Explore spacious two-bedroom apartments located in Williston, ND. Dakota Ridge offers modern living with top-notch amenities.",
      "page_copy": "Welcome to Dakota Ridge, where our two-bedroom apartments in Williston, ND, redefine comfortable living. Each apartment is designed with open layouts, ensuring ample space and convenience, perfect for singles, couples, or small families.\n\nNestled in the heart of Williston, our community combines modern amenities such as wood-style flooring, full-size washers and dryers, and private balconies. Plus, with select units offering vaulted ceilings, our two-bedroom apartments provide a bright and airy atmosphere. Whether you're relaxing at home or exploring the local North Dakota area, Dakota Ridge provides the ideal backdrop for a comfortable and modern lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/5693657831178240/019d019f-f9c4-714d-9404-f5f8cb6911fc.webp",
      "featured_image_media": {
        "alt_text": "Living room with a light gray sofa, coffee table, and TV.",
        "public_id": "019d019f-f9c4-714d-9404-f5f8cb6911fc",
        "storage_key": "property/5693657831178240/019d019f-f9c4-714d-9404-f5f8cb6911fc.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Williston, ND",
      "seo_description": "Discover spacious two-bedroom apartments at Dakota Ridge in Williston, ND. Enjoy modern living with excellent amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-williams-county-nd",
      "search_query": "three bedroom apartments williams county nd",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Williams County, ND",
      "h2_subtitle": "Find spacious three-bedroom apartments in Williams County, ND. Dakota Ridge offers comfort and style in a prime location.",
      "page_copy": "At Dakota Ridge, our three-bedroom apartments in Williams County, ND, offer a blend of modern design and comfortable living. Each unit features expansive layouts, perfect for families or those needing additional space. \n\nEnjoy the convenience of having a full-size washer and dryer in your apartment, along with the luxury of a private balcony. Select apartments offer the impressive feature of oversized two-car garages, catering to all your storage and parking requirements. Located in the vibrant area of Williston, ND, Dakota Ridge combines exceptional amenities with the comfort and security of a close-knit community, making it the perfect choice for your next home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/5693657831178240/019d019f-f9c4-714d-9404-f5f8cb6911fc.webp",
      "featured_image_media": {
        "alt_text": "Living room with a light gray sofa, coffee table, and TV.",
        "public_id": "019d019f-f9c4-714d-9404-f5f8cb6911fc",
        "storage_key": "property/5693657831178240/019d019f-f9c4-714d-9404-f5f8cb6911fc.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Williams County, ND",
      "seo_description": "Explore spacious three-bedroom apartments at Dakota Ridge in Williams County, ND. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "source": "generator",
      "page_item_url": "apartments-near-missouri-ridge-school-williams-county",
      "search_query": "apartments near missouri ridge school williams county",
      "category": "School",
      "h1_title": "Apartments Near Missouri Ridge School",
      "h2_subtitle": "Discover apartments near Missouri Ridge School in Williams County. Dakota Ridge offers modern living close to educational facilities.",
      "page_copy": "Dakota Ridge is the ideal community for those seeking apartments near Missouri Ridge School in Williams County. Our location provides a perfect blend of convenience and comfort, just a short drive away from this renowned educational facility. \n\nEnjoy spacious living in our modern two- and three-bedroom apartments, featuring amenities like wood-style flooring, private balconies, and full-size washers and dryers. Our family-friendly environment is perfect for those who value proximity to education alongside stylish living. With its great location and welcoming community, Dakota Ridge is a prime choice for families and individuals alike.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/5693657831178240/019d019f-f9c4-714d-9404-f5f8cb6911fc.webp",
      "featured_image_media": {
        "alt_text": "Living room with a light gray sofa, coffee table, and TV.",
        "public_id": "019d019f-f9c4-714d-9404-f5f8cb6911fc",
        "storage_key": "property/5693657831178240/019d019f-f9c4-714d-9404-f5f8cb6911fc.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Missouri Ridge School, Williams County",
      "seo_description": "Find modern apartments at Dakota Ridge, close to Missouri Ridge School in Williams County. Convenient and comfortable living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "source": "generator",
      "page_item_url": "apartments-near-spring-lake-park-williston",
      "search_query": "apartments near Spring Lake Park Williston",
      "category": "Park",
      "h1_title": "Apartments Near Spring Lake Park, Williston",
      "h2_subtitle": "Live close to Spring Lake Park with our premium apartments in Williston. Discover Dakota Ridge's excellent location and amenities.",
      "page_copy": "Experience the joy of living near Spring Lake Park in Williston, ND at Dakota Ridge. Our well-located apartments provide easy access to this beautiful local park, ensuring plenty of recreational opportunities just minutes from home.\n\nAt Dakota Ridge, choose from spacious two- and three-bedroom layouts that offer everything you need for comfortable living, including wood-style flooring, private balconies, and pet-friendly environments. Our proximity to Spring Lake Park means you can enjoy walking trails, picnics, and community events with ease, making Dakota Ridge the ideal choice for those who love outdoor activities and a serene setting.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/5693657831178240/019d019f-f9c4-714d-9404-f5f8cb6911fc.webp",
      "featured_image_media": {
        "alt_text": "Living room with a light gray sofa, coffee table, and TV.",
        "public_id": "019d019f-f9c4-714d-9404-f5f8cb6911fc",
        "storage_key": "property/5693657831178240/019d019f-f9c4-714d-9404-f5f8cb6911fc.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Spring Lake Park in Williston",
      "seo_description": "Discover Dakota Ridge: Offering modern apartments close to Spring Lake Park in Williston. Enjoy easy access to nature and great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5693657831178240",
      "source": "generator",
      "page_item_url": "dakota-ridge-apartments-missouri-ridge-commercial-park",
      "search_query": "Dakota Ridge apartments by Missouri Ridge Commercial Park",
      "category": "Park",
      "h1_title": "Dakota Ridge Apartments by Missouri Ridge Park",
      "h2_subtitle": "Explore Dakota Ridge apartments located near Missouri Ridge Commercial Park. Experience great amenities and convenient living.",
      "page_copy": "Experience contemporary comfort at Dakota Ridge, located just a short distance from Missouri Ridge Commercial Park. These apartments provide an ideal living situation for those who want easy access to local business hubs while enjoying a serene residential environment.\n\nOur community features spacious two- and three-bedroom floor plans with modern amenities, such as wood-style flooring, built-in desks, and a game room for relaxation. Being so close to Missouri Ridge Commercial Park also means you're conveniently near essential services and shopping destinations, making Dakota Ridge an excellent choice for both professionals and families.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/5693657831178240/019d019f-f9c4-714d-9404-f5f8cb6911fc.webp",
      "featured_image_media": {
        "alt_text": "Living room with a light gray sofa, coffee table, and TV.",
        "public_id": "019d019f-f9c4-714d-9404-f5f8cb6911fc",
        "storage_key": "property/5693657831178240/019d019f-f9c4-714d-9404-f5f8cb6911fc.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dakota Ridge Apartments by Missouri Ridge Park",
      "seo_description": "Discover Dakota Ridge’s prime location near Missouri Ridge Commercial Park. Enjoy modern amenities and convenient living in Williston.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "4725"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "9147445586"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=7017125691"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-KXGNCSLD"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 7.3"
    },
    {
      "ID": "custom_rentgrata_token",
      "type": "STRING",
      "value": "797f1ffd-5132-4108-971a-2e78f2f08a8b"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Homestead"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/5c60a145-e013-4076-83d9-5907de867c10/app.js?property=5c60a145-e013-4076-83d9-5907de867c10&propertyName=Dakota+Ridge&channelUuid=c248eb7c-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "47606919339"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Ii9tVWZhS0x5ZUtlNXBwdXFhbkdoTUE9PSIsInZhbHVlIjoiR2UzUWZRbGg4cERaUnh4aVhoVVByZz09IiwibWFjIjoiZDYxYTUyYzZjNzYzMzEyMDU2MzYzMmEzNTc0MTQ1ZjNhMmI3NmNkZDljNGVjZmJjNDFiMzJmNzFhODhlY2I2MCJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_qb_id": "4725",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "9147445586",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=7017125691",
  "custom_google_gtm_id": "GTM-KXGNCSLD",
  "custom_rollout_phase": "Phase 7.3",
  "custom_rentgrata_token": "797f1ffd-5132-4108-971a-2e78f2f08a8b",
  "custom_vibesites_theme": "Homestead",
  "custom_ads_subscription": "none",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/5c60a145-e013-4076-83d9-5907de867c10/app.js?property=5c60a145-e013-4076-83d9-5907de867c10&propertyName=Dakota+Ridge&channelUuid=c248eb7c-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>",
  "custom_seo_subscription": "none",
  "custom_hubspot_company_id": "47606919339",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Ii9tVWZhS0x5ZUtlNXBwdXFhbkdoTUE9PSIsInZhbHVlIjoiR2UzUWZRbGg4cERaUnh4aVhoVVByZz09IiwibWFjIjoiZDYxYTUyYzZjNzYzMzEyMDU2MzYzMmEzNTc0MTQ1ZjNhMmI3NmNkZDljNGVjZmJjNDFiMzJmNzFhODhlY2I2MCJ9",
  "custom_audioeye_site_id": "a4d0309a-29ec-423e-a50c-baca5c48548a",
  "custom_audioeye_site_hash": "d7c72205f86d949c291484c3f5b957ab"
};

export const generatedAt = '2026-10-29T23:17:37.413Z';
